export default __webpack_public_path__ + "static/media/google.d7cdc69b.svg";